import { LineItemsHeaderDisplay } from "../LineItemsSpreadsheet";

export function buildHeaderRowsData(reforecastDisplay: LineItemsHeaderDisplay, budgetDisplay?: LineItemsHeaderDisplay): string[][] {
    const reforecastYearSuffix = `0000${reforecastDisplay.headerYear.toString()}`.slice(-2);
    const reforecastNextYearSuffix = `0000${(reforecastDisplay.headerYear + 1).toString()}`.slice(-2);
    const monthlyColumns = [...reforecastDisplay.headerMonths.map((mo, idx) => `${mo} ${reforecastDisplay.yearIncrementIndex && idx > reforecastDisplay.yearIncrementIndex ? reforecastNextYearSuffix : reforecastYearSuffix}`), `TOTAL ${reforecastYearSuffix}`];
    if(budgetDisplay) {
        const budgetYearSuffix = `0000${budgetDisplay.headerYear.toString()}`.slice(-2);
        const budgetNextYearSuffix = `0000${(budgetDisplay.headerYear + 1).toString()}`.slice(-2);
        monthlyColumns.push(...budgetDisplay.headerMonths.map((mo, idx) => `${mo} ${budgetDisplay.yearIncrementIndex && idx > budgetDisplay.yearIncrementIndex ? budgetNextYearSuffix : budgetYearSuffix}`));
        monthlyColumns.push(`TOTAL ${budgetYearSuffix}`);
    }
    return [
        ["Item Name", "Property", "GL Account", ...monthlyColumns]
    ];
}